
import React from 'react'
import { MessageTypeConstants } from '../../../../services/bot/Message';
import { CssTextField, FormControlContainer, IconButtonContainer, Label, MenuItemContainer, SelectContainer, TodayBtn } from '../styled';
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { DatePicker } from "@mui/x-date-pickers";

import momentTz from "moment-timezone";
import { useDispatch } from 'react-redux';
import { handleCalendarToolBarChange } from '../../../../state/actions/tabStack';
import { getLabelForView, getLocalTimezone } from '../../../../utils/moment';


const CalendarTools = ({
    selectedDate,
    label,
    currView,
    messageType,
    setSelectedDate,
    handleSelectedDate,
    view,
    views,
    firstTools,
    secondTools,
    onNavigate = () => { },
    onNavigateTable = () => { },
    handleChange = () => { }
}) => {

    const dispatch = useDispatch();
    const localTZ = getLocalTimezone();

    // ---------------------
    // COMMON LABEL HANDLER
    // ---------------------
    const updateLabel = (date) => {
        const lbl = getLabelForView(date, currView);
        dispatch(handleCalendarToolBarChange({ label: lbl }));
    };

    return (
        <>
            {
                firstTools &&
                <>
                    {messageType === MessageTypeConstants.MESSAGE_TYPE_CALENDAR && (
                        <div>
                            <LocalizationProvider dateAdapter={AdapterMoment}>
                                <DatePicker
                                    inputFormat="DD-MM-YYYY"
                                    label="Select Date"
                                    value={selectedDate}
                                    slotProps={{
                                        textField: {
                                            InputProps: { sx: { height: 42 } },
                                            sx: {
                                                "& .MuiInputBase-root": { height: 42 },
                                                "& input": { padding: "2px 14px" },
                                            },
                                        },
                                    }}
                                    onChange={(newDate) => {
                                        const date = momentTz(newDate).tz(localTZ);
                                        setSelectedDate(date);
                                        handleSelectedDate(date, currView);
                                        updateLabel(date);
                                    }}
                                    renderInput={(params) => {
                                        return (
                                            <CssTextField
                                                variant="outlined"
                                                id="date"
                                                type="date"
                                                label="Select Date"
                                                InputLabelProps={{ shrink: true }}
                                                {...params}
                                            />
                                        );
                                    }}
                                />
                            </LocalizationProvider>
                        </div>
                    )}

                    {messageType === MessageTypeConstants.MESSAGE_TYPE_CALENDAR && (
                        <>
                            <div>
                                <IconButtonContainer
                                    onClick={() =>  onNavigateTable("PREV")}
                                    size="large"
                                >
                                    <KeyboardArrowLeftIcon color="#98B0C8" />
                                </IconButtonContainer>
                            </div>
                            <div>
                                <Label variant="subtitle1" className="!whitespace-nowrap">
                                    {label}
                                </Label>
                            </div>
                            <div>
                                <IconButtonContainer
                                    onClick={() => onNavigateTable("NEXT")}
                                    size="large"
                                >
                                    <KeyboardArrowRightIcon color="#98B0C8" />
                                </IconButtonContainer>
                            </div>
                            <div>
                                <TodayBtn
                                    onClick={() =>  onNavigateTable("TODAY")}
                                    variant="outlined"
                                    margin="dense"
                                >
                                    Today
                                </TodayBtn>
                            </div>
                        </>
                    )}
                </>
            }
            {
                secondTools &&
                <>
                    {messageType === MessageTypeConstants.MESSAGE_TYPE_CALENDAR && views && views.length > 0 && (
                        <div>
                            <FormControlContainer variant="outlined" margin="dense">
                                <SelectContainer
                                    value={view}
                                    onChange={handleChange}
                                    sx={{ height: 30 }}
                                >
                                    {views.map((value) => (
                                        <MenuItemContainer value={value} key={value} sx={{ fontSize: 12 }}>
                                            {value}
                                        </MenuItemContainer>
                                    ))}
                                </SelectContainer>
                            </FormControlContainer>
                        </div>
                    )}
                </>
            }
        </>
    )
};

export default CalendarTools
